'use client';
import { useState } from 'react';
import { Heart } from 'react-feather';
import AuthUser from '@/utils/AuthUser';
import classes from '@/components/UI/FavoriteIcon.module.css';
import { useAlertContext } from '@/context/alert';
import { useAuthContext } from '@/context';
import axios from 'axios';

const SavedSearches = (props) => {
	const { SET_ALERT } = useAlertContext();

	const ADD_TO_SAVED_SEARCHES = async (savedSearch) => {
		if (!auth.isAuthenticated) {
			SET_ALERT({
				msg: 'You have to be logged in first',
				type: 'danger',
			});
			return;
		}

		await axios
			.post(
				`${process.env.NEXT_PUBLIC_SERVER_API}/api/savedSearches/${auth.user._id}`,
				savedSearch
			)
			.then((res) => {
				SET_ALERT({
					msg: `Search saved!`,
					type: 'success',
				});
			})
			.catch((error) => {
				SET_ALERT({
					msg: `Error saving search`,
					type: 'success',
				});
			});
	};

	const {
		keyword,
		brand,
		category,
		option,
		minPrice,
		maxPrice,
		condition,
		type,
	} = props;

	const savedSearch = {
		keyword: keyword,
		brand: brand,
		category: category,
		option: option,
		type: type,
		minPrice: minPrice,
		maxPrice: maxPrice,
		condition: condition,
	};

	const [requestAuth, setRequestAuth] = useState(false);

	const { auth } = useAuthContext();

	const AddToSavedSearchesHandler = () => {
		if (!auth.isAuthenticated) {
			setRequestAuth(true);
		} else if (
			savedSearch.keyword != null ||
			savedSearch.brand != null ||
			savedSearch.category != null ||
			savedSearch.option != null ||
			savedSearch.type != null ||
			savedSearch.minPrice != null ||
			savedSearch.maxPrice != null ||
			savedSearch.condition != null
		) {
			process.env.NEXT_PUBLIC_NODE_ENV === 'production' &&
				process.env.OG_DB === 'true' &&
				window.analytics.track('save_search', {
					search: savedSearch,
				});
			ADD_TO_SAVED_SEARCHES(savedSearch);
		} else {
			SET_ALERT({ msg: 'No filters selected to save!', type: 'danger' });
		}
	};
	return (
		<>
			{requestAuth && (
				<AuthUser
					open={!auth.isAuthenticated}
					setRequestAuth={setRequestAuth}
				/>
			)}

			<div className={props.className} onClick={AddToSavedSearchesHandler}>
				Save this Search{' '}
				<Heart
					className={classes.margin}
					style={{ marginLeft: '.4em', marginTop: '-.1em' }}
					size={15}
				/>
			</div>
		</>
	);
};

export default SavedSearches;
